/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {JobCreateState} from '@ion/applications/src/components/jobs/state';
import {GlobalSearchState} from '@ion/applications/src/globalsearch/state';
import {NotificationsPanelState} from '@ion/applications/src/notifications/state';
import {AdminGroupsState} from '@ion/applications/src/pages/admin/accounts/state';
import {GroupsState} from '@ion/applications/src/pages/admin/groups/state';
import {AdminNotificationsState} from '@ion/applications/src/pages/admin/notifications/state';
import {DevicesState} from '@ion/applications/src/pages/devices/state';
import {JobStatusState} from '@ion/applications/src/pages/jobstatus/state';
import {ApplicationIdsState} from '@ion/applications/src/pages/manufacturing/ApplicationIds/state';
import {DevicePartNumbersState} from '@ion/applications/src/pages/manufacturing/DevicePartNumbers/state';
import {ManufacturedDevicesState} from '@ion/applications/src/pages/manufacturing/devices/state';
import {InventoryDevicesState} from '@ion/applications/src/pages/manufacturing/inventory/state';
import {ShipmentsState} from '@ion/applications/src/pages/manufacturing/shipments/state';
import {ReportsState} from '@ion/applications/src/pages/reports/state';
import {NotificationTypeState} from '@ion/applications/src/pages/systemconfig/notification-type/state';
import {AdminUsersState, IApplicationStore} from '@ion/applications/src/types/redux';
import {DashboardState} from '@/routes/dashboard/state';
import {AdminAEMPConfigState} from '@/store/reducers/admin-aempconfig';
import {AdminApplicationsState} from '@/store/reducers/admin-applications';
import {AdminDeviceConfigsState} from '@/store/reducers/admin-deviceconfigs';
import {AdminPegBehaviorsState} from '@/store/reducers/admin-pegbehaviors';
import {AdminPegLabelsState} from '@/store/reducers/admin-peglabels';
import {DeviceFilesState} from '@/store/reducers/devicefiles';
import {DeviceTypesState} from '@/store/reducers/devicetypes';
import {DownloadJobsState} from '@/store/reducers/downloadjobs';
import {ErrorsState} from '@/store/reducers/errors';
import {GlobalGroupState} from '@/store/reducers/global-group-chooser';
import {InitializationState} from '@/store/reducers/initialization';
import {KeyfileBuilderState} from '@/store/reducers/keyfileBuilder';
import {LoginState} from '@/store/reducers/login';
import {NavState} from '@/store/reducers/nav';
import {UserPromptState} from '@/store/reducers/user-prompt';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '@ion/applications/src/types/redux';

export interface ApplicationState extends IApplicationStore {
  initialization: InitializationState;
  globalGroup: GlobalGroupState;
  globalSearch: GlobalSearchState;
  errors: ErrorsState
  login: LoginState
  nav: NavState
  dashboard: DashboardState
  userPrompt: UserPromptState,
  jobCreate: JobCreateState,
  adminApplications: AdminApplicationsState,
  deviceConfigs: AdminDeviceConfigsState,
  pegBehaviors: AdminPegBehaviorsState,
  pegLabels: AdminPegLabelsState,
  adminGroups: AdminGroupsState,
  adminAEMPConfig: AdminAEMPConfigState,
  devices: DevicesState,
  adminNotifications: AdminNotificationsState,
  devicetypes: DeviceTypesState,
  deviceFiles: DeviceFilesState,
  adminUsers: AdminUsersState,
  notificationType: NotificationTypeState,
  notificationsPanel: NotificationsPanelState,
  jobStatus: JobStatusState,
  groups: GroupsState,
  reports: ReportsState,
  downloadJobs: DownloadJobsState,
  keyfileBuilder: KeyfileBuilderState,
  inventory: InventoryDevicesState,
  applicationIds: ApplicationIdsState,
  shipments: ShipmentsState,
  devicePartNumbers: DevicePartNumbersState,
  manufacturedDevices: ManufacturedDevicesState
};

export enum ExportContext {
  applications = 'applications',
  aempConfig = 'aempconfigs',
  deviceTypes = 'deviceTypes',
  notificationType = 'notificationType',
  groups = 'groups',
  deviceFiles = 'deviceFiles',
  reports = 'reports',
  device = 'device',
  pegBehaviors = 'pegBehaviors',
  downloadJobs = 'downloadJobs',
  filemeta = 'filemeta'
}
